export const LogLevel = [
  { value: 0, name: 'Unknown'},
  { value: 1, name: 'Trace'},
  { value: 2, name: 'Debug'},
  { value: 3, name: 'Info'},
  { value: 4, name: 'Warn'},
  { value: 5, name: 'Error'},
  { value: 6, name: 'Critical'},
];
